export const LIST_CARDS_PATH = '/cards';
export const CARD_ASSOCIATE_TO_COSTCENTER = '/card/associateCard';
export const ASSOCIATE_CARD_PATH = '/card/associateCard';
